import BasicIcon from "components/basic-icon/BasicIcon";
import FormComponents from "components/forms/FormComponents";
import Link from "components/link/Link";
import { trials } from "data-files/duties";
import { locations } from "data-files/locations";
import { quests } from "data-files/quests";
import { GameData, Icon, LinkType, Modal } from "enums";
import manager from "managers/app";
import ModalContent from "modals/content/ModalContent";
import { TrialsModalProps } from "modals/content/trials/types";
import ModalFooter from "modals/footer/ModalFooter";
import ModalHeader from "modals/header/ModalHeader";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { OutputString } from "translations/types";
import { AppState } from "types/app";
import { Info, Obtained } from "types/game";
import utils from "util/utils";
import "./TrialsModal.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		trials: state.modal[Modal.TRIALS],
	};
};

class TrialsModal extends Component<TrialsModalProps> {
	render():JSX.Element{
		return (
			<div id={Modal.TRIALS} className="modal-wrapper">
				<ModalHeader text="Trials" icon={Icon.TRIAL} />
				<ModalContent>
					<div className="trial-wrapper">
						{this.props.trials.map((obtainedTrial) => {
							let isTrial = false;
							let trial = trials[GameData.Trial.UNKNOWN];
							let obtainedLocation:Obtained.Location = { location: GameData.MapLocation.UNKNOWN, x: -1, y: -1 };

							if(utils.guards.isEnumValue(GameData.Trial, obtainedTrial)){
								trial = trials[obtainedTrial];
								isTrial = true;
							}else if(utils.guards.isEnumValue(GameData.MapLocation, obtainedTrial)){
								obtainedLocation = { location: obtainedTrial, x: -1, y: -1 };
							}

							return isTrial ? this.getTrialCard(trial) : this.getLocationCard(obtainedLocation);
						})}
					</div>
				</ModalContent>
				<ModalFooter>
					<FormComponents.Button text="Close" onClick={manager.modal.close} translate={true} />
				</ModalFooter>
			</div>
		);
	}

	getTrialCard(trial:Info.Trial):JSX.Element{
		const unlockQuest = quests[trial.unlocked];
		return <div key={trial.name} className="trial-card">
			<h3 className="trial-name"><Link type={LinkType.LODESTONE} lodestoneType={trial.type} lodestoneID={trial.lodestoneID} text={trial.name} /></h3>
			<p className="trial-unlocked">
				<span>{t.t("Quest to unlock")}</span><Link type={LinkType.LODESTONE} lodestoneType={unlockQuest.type} lodestoneID={unlockQuest.lodestoneID} text={unlockQuest.name} />
			</p>
		</div>;
	}

	getLocationCard(obtainedLocation:Obtained.Location):JSX.Element{
		const locationInfo = locations[obtainedLocation.location];
		let trialName:OutputString = "Any Trials";

		if(
			obtainedLocation.location === GameData.MapLocation.BOZJA
			|| obtainedLocation.location === GameData.MapLocation.BOZJA_SOUTH
			|| obtainedLocation.location === GameData.MapLocation.BOZJA_MIDDLE
			|| obtainedLocation.location === GameData.MapLocation.BOZJA_NORTH
			|| obtainedLocation.location === GameData.MapLocation.ZADNOR
			|| obtainedLocation.location === GameData.MapLocation.ZADNOR_SOUTH
			|| obtainedLocation.location === GameData.MapLocation.ZADNOR_MIDDLE
			|| obtainedLocation.location === GameData.MapLocation.ZADNOR_NORTH
		){
			trialName = "Any Critical Engagement";
		}

		return <div key={locationInfo.region ? locationInfo.region : locationInfo.map} className="trial-card">
			<h3 className="trial-name">{t.t(trialName)}</h3>
			<div className="trial-location-wrapper">
				<div className="trial-location">
					<span><BasicIcon icon={Icon.MAP} tooltip="Map" /> {t.t(locationInfo.map)}</span>
					{locationInfo.region ? <span><BasicIcon icon={Icon.REGION} tooltip="Region" /> {locationInfo.region ? t.t(locationInfo.region) : null}</span> : null}
					{locationInfo.teleport ? <span><BasicIcon icon={Icon.TELEPORT} tooltip="Teleport" /> {t.t(locationInfo.teleport)}</span> : null}
				</div>
			</div>
		</div>;
	}
}
export default connect(mapStateToProps)(TrialsModal);
